// frontend/src/pages/EditRegulation.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import "./RegulationForm.css";

const API = process.env.REACT_APP_API;

const EditRegulation = () => {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const { token } = useAuth();
  

  useEffect(() => {
    const fetchRegulation = async () => {
      try {
        const { data } = await axios.get(`${API}/api/regulations`);
        const reg = data.find((r) => r._id === id);
        if (reg) {
          setTitle(reg.title);
        } else {
          toast.error("קובץ לא נמצא");
          navigate("/regulations");
        }
      } catch {
          toast.error("שגיאה בטעינת הנתונים");
      }
    };
    fetchRegulation();
  }, [id, navigate]);

    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);


      if (!title) {
        toast.error("נא למלא את השם");
        return;
      }

      try {
        const formData = new FormData();
        formData.append("title", title);
        if (file) formData.append("pdf", file);

        await axios.put(`${API}/api/regulations/${id}`, formData, {
            headers: { 
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`   // 👈 חובה
            },
        });

        toast.success("הקטיגוריה עודכנה בהצלחה!");
        navigate("/leagues");
      } catch (err) {
        console.error("Error updating regulation:", err.response?.data || err.message);
        toast.error("שגיאה בעדכון הקטיגוריה");
      } finally {
        setLoading(false);
      }
    };

    // מחיקה
    const handleDelete = async () => {
        if (!window.confirm(`את/ה בטוח/ה שברצונך למחוק את הקטיגוריה - "${title}"?`)) return;

        try {
            await axios.delete(`${API}/api/regulations/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success('❌ הקטיגוריה נמחקה בהצלחה');
            navigate("/regulations");
        } catch (err) {
            console.error("שגיאה במחיקת הקטיגוריה:", err);
            toast.error('❌ מחיקת הקטיגוריה נכשלה');
        }
    };

  return (
    <div className="regulation-form-container">
        {/* אייקון הבית בפינה שמאלית עליונה */}
        <div className="home-icon">
            <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")}/>
        </div>
        <div className="back-icon">
            <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/regulations")}/>
        </div>
      <h2>עריכת שם וקובץ "{title}"</h2>
      <form onSubmit={handleSubmit} className="regulation-form">
        <input
          type="text"
          placeholder="שם הקטיגוריה"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <input type="file" onChange={(e) => setFile(e.target.files[0])} />
        <div className="buttons">
            <button
            type="submit"
            disabled={loading}
            >
              {loading ? "שומר..." : "💾 שמירת שינויים"}
            </button>
            <button type="button" onClick={handleDelete} className="delete">🗑️ מחיקת קטגוריה</button>
            <button type="button" onClick={() => navigate("/leagues")}>⬅️ חזרה</button>
        </div>
      </form>
    </div>
  );
};

export default EditRegulation;
